import React from "react";
import Fallback from "@components/templates/Fallback";

export default function FallbackScreen() {
  return <Fallback />;
}
